import { GameFilterCategoriesConfig, GameFilterCategoryTypesEnum } from './games-filter-categories.models';

export const gamesBasePath = '/games';

export const gameFilterCategoriesConfig: GameFilterCategoriesConfig = {
  type: GameFilterCategoryTypesEnum.GameType,
  closeBtnIconPath: '/assets/icons/close.svg',
  filterArrowIconPath: '/assets/games-filter/forward-arrow.svg',
  title: 'Game type',
  filterTypes: [
    {
      label: 'all',
      iconPath: '/assets/games-filter/game-type/all.svg',
      redirectUrl: `${gamesBasePath}?cat=all`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobileall`
    },
    {
      label: 'new',
      iconPath: '/assets/games-filter/game-type/new.svg',
      redirectUrl: `${gamesBasePath}?cat=new`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilenew`
    },
    {
      label: 'slots',
      iconPath: '/assets/games-filter/game-type/slots.svg',
      redirectUrl: `${gamesBasePath}?cat=slots`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobileslots`
    },
    {
      label: 'jackpots',
      iconPath: '/assets/games-filter/game-type/jackpots.svg',
      redirectUrl: `${gamesBasePath}?type=jackpots`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilejackpots`
    },
    {
      label: 'live',
      iconPath: '/assets/games-filter/game-type/live-casino.svg',
      redirectUrl: `${gamesBasePath}?cat=live`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilelive`
    },
    {
      label: 'blackjack',
      iconPath: '/assets/games-filter/game-type/blackjack.svg',
      redirectUrl: `${gamesBasePath}?cat=blackjack`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobileblackjack`
    },
    {
      label: 'roulette',
      iconPath: '/assets/games-filter/game-type/roulette.svg',
      redirectUrl: `${gamesBasePath}?cat=roulette`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobileroulette`
    },
    {
      label: 'classic',
      iconPath: '/assets/games-filter/game-type/poker.svg',
      redirectUrl: `${gamesBasePath}?cat=classic`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobileclassic`
    },
    {
      label: 'megaways',
      iconPath: '/assets/games-filter/game-type/megaways.svg',
      redirectUrl: `${gamesBasePath}?cat=megaways`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilemegaways`
    },
    {
      label: 'fun',
      iconPath: '/assets/games-filter/game-type/scratch.svg',
      redirectUrl: `${gamesBasePath}?cat=fun`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilefun`
    },
    {
      label: 'dropsandwins',
      iconPath: '/assets/games-filter/game-type/dropsandwins.svg',
      redirectUrl: `${gamesBasePath}?cat=dropsandwins`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobiledropsandwins`
    },
    {
      label: 'mustgojackpots',
      iconPath: '/assets/games-filter/game-type/mustgojackpots.svg',
      redirectUrl: `${gamesBasePath}?cat=mustgojackpots`,
      redirectUrlMobile: `${gamesBasePath}?cat=mobilemustgojackpots`
    }
  ]
}

export const gameFilterCategoriesConfigStudio: GameFilterCategoriesConfig = {
  type: GameFilterCategoryTypesEnum.Studio,
  closeBtnIconPath: '/assets/icons/close.svg',
  filterArrowIconPath: '/assets/icons/forward-arrow.svg',
  title: 'Studio',
  filterTypes: []
}

export const gameFilterCategoriesConfigPopularStudios: GameFilterCategoriesConfig = {
  type: GameFilterCategoryTypesEnum.Studio,
  closeBtnIconPath: '/assets/icons/close.svg',
  filterArrowIconPath: '/assets/icons/forward-arrow.svg',
  title: 'Studio',
  filterTypes: [
    {
      label: 'PlaynGo',
      iconPath: '/assets/games-filter/studio/PlaynGo.png',
      redirectUrl: `${gamesBasePath}?provider=playngo`,
    },
    {
      label: 'NetEnt',
      iconPath: '/assets/games-filter/studio/NetEnt.png',
      redirectUrl: `${gamesBasePath}?provider=netent`,
    },
    {
      label: 'Evolution Gaming (NetEnt)',
      iconPath: '/assets/games-flter/studio/EvolutionGaming.png',
      redirectUrl: `${gamesBasePath}?provider=evolution-gaming`
    },
    {
      label: 'Big Time Gaming',
      iconPath: '/assets/games-filter/studio/BigTimeGaming.png',
      redirectUrl: `${gamesBasePath}?provider=big-time-gaming`
    },
    {
      label: 'Pragmatic Play',
      iconPath: '/assets/games-filter/studio/Pragmatic.png',
      redirectUrl: `${gamesBasePath}?provider=pragmatic`
    },
    {
      label: 'Microgaming',
      iconPath: '/assets/games-filter/studio/Microgaming.png',
      redirectUrl: `${gamesBasePath}?provider=microgaming`,
    },
    {
      label: 'No Limit City',
      iconPath: '/assets/games-filter/studio/NoLimitCity.png',
      redirectUrl: `${gamesBasePath}?provider=nolimit-city`
    },
    {
      label: 'Red Tiger Gaming',
      iconPath: '/assets/games-filter/studio/RedTiger.png',
      redirectUrl: `${gamesBasePath}?provider=red-tiger`,
    },
    {
      label: 'GreenTube',
      iconPath: '/assets/games-filter/studio/GreenTube.png',
      redirectUrl: `${gamesBasePath}?provider=greentube`
    }
  ]
}
